import {MaintenanceType } from "../validations";

export const defaultValueMaintenance = (value: Partial<MaintenanceType> = {}): MaintenanceType => ({
    maintenance_schedule: value.maintenance_schedule || "1",
    last_maintenance: value.last_maintenance || "",
    maintenance_cost: value.maintenance_cost || 0,
    asset_maintenance_id: value.asset_maintenance_id || undefined
});
